import { render, staticRenderFns } from "./Pro.vue?vue&type=template&id=ec2d1eea&scoped=true&"
import script from "./Pro.vue?vue&type=script&lang=js&"
export * from "./Pro.vue?vue&type=script&lang=js&"
import style0 from "./Pro.vue?vue&type=style&index=0&id=ec2d1eea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2d1eea",
  null
  
)

export default component.exports